export function ppcSeverityClass(severity) {
  if (severity === 'green') return 'text-[var(--color-success-text)]';
  if (severity === 'yellow') return 'text-[var(--color-warning-text)]';
  if (severity === 'red') return 'text-[var(--color-error-text)]';
  return 'text-[var(--color-disabled)]';
}

export function ppcAmpelBgClass(severity) {
  if (severity === 'green') return 'bg-[var(--color-success-text)]';
  if (severity === 'yellow') return 'bg-[var(--color-warning-text)]';
  if (severity === 'red') return 'bg-[var(--color-error-text)]';
  return 'bg-[var(--color-disabled)]';
}

export function openCommitmentsAmpelClass(overdueCount, openCount) {
  if (overdueCount > 0) return 'bg-[var(--color-error-text)]';
  if (openCount > 0) return 'bg-[var(--color-warning-text)]';
  return 'bg-[var(--color-success-text)]';
}

export function milestonesAmpelClass(overdueCount, totalCount, completedCount) {
  if (overdueCount > 0) return 'bg-[var(--color-error-text)]';
  if (totalCount > 0 && completedCount < totalCount) return 'bg-[var(--color-warning-text)]';
  return 'bg-[var(--color-success-text)]';
}

export function hasPpcSample(currentWeek, minSample = 5) {
  return Boolean(currentWeek && (currentWeek.n ?? 0) >= minSample);
}

export function ppcTrendArrow(direction) {
  if (direction === 'up') return '↑';
  if (direction === 'down') return '↓';
  if (direction === 'flat') return '→';
  return '';
}

export function formatPpcTrend(delta, direction) {
  if (delta === null || delta === undefined || !direction) return null;
  const sign = delta > 0 ? '+' : '';
  return `${ppcTrendArrow(direction)} ${sign}${delta}%`;
}

export function hasPpcValue(currentWeek) {
  return Boolean(currentWeek && currentWeek.n > 0 && currentWeek.ppc !== null && currentWeek.ppc !== undefined);
}

export function chartBarHeight(ppc, maxPpc = 100) {
  if (ppc === null || ppc === undefined) return 8;
  return Math.max(8, Math.round((ppc / maxPpc) * 100));
}
